import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGift } from "@fortawesome/free-solid-svg-icons";
import useWelcomeBonus, { welcomeBonusText } from "../../hooks/useWelcomeBonus";
import { bonusLotteriesText } from "../../utils/bonusRules";
import styles from "./Bonus.module.css";

/**
 * Franja promocional del bono de bienvenida (landing y registro).
 * Se oculta si el programa está inactivo o si el usuario ya hizo su primera recarga.
 * @param {object} props
 * @param {"landing"|"compact"} [props.variant]
 * @param {string} [props.className]
 */
export default function WelcomeBonusStrip({ variant = "landing", className = "" }) {
  const { welcome } = useWelcomeBonus();
  const text = welcomeBonusText(welcome);
  if (!text || welcome?.eligible === false) return null;

  const days = Number(welcome.validity_days);
  const details = [
    "Tú eliges el número",
    bonusLotteriesText(welcome),
    Number.isFinite(days) && days > 0 ? `Tienes ${days} días para usarlo` : null,
  ].filter(Boolean);

  return (
    <aside
      className={`${styles.strip} ${variant === "compact" ? styles.stripCompact : ""} ${className}`}
      aria-label="Bono de bienvenida"
    >
      <span className={styles.stripIcon} aria-hidden="true">
        <FontAwesomeIcon icon={faGift} />
      </span>
      <div className={styles.stripBody}>
        <p className={styles.stripEyebrow}>{welcome.name || "Bono de bienvenida"}</p>
        <p className={styles.stripText}>{text}</p>
        <p className={styles.stripDetails}>{details.join(" · ")}.</p>
      </div>
    </aside>
  );
}
